
<template>
    <div>
        <b-row class="mt-3">
            <b-col md="2">
                <b-form-group label="First Name" label-for="firstName">
                    <!-- <v-select v-model="first_name" label="title" :options="option" placeholder="First Name"
                        @input="sendValues" /> -->
                    <b-form-input v-model="first_name" placeholder="First Name" @input="sendValues" />
                </b-form-group>
            </b-col>
            <b-col md="2">
                <b-form-group label="Second Name" label-for="secondName">
                    <!-- <v-select v-model="second_name" label="title" :options="option" placeholder="Second Name"
                        @input="sendValues" /> -->
                    <b-form-input v-model="second_name" placeholder="Second Name" @input="sendValues" />

                </b-form-group>
            </b-col>
            <b-col md="2">
                <b-form-group label="Third Name" label-for="thirdName">
                    <!-- <v-select v-model="third_name" label="title" :options="option" placeholder="Third name"
                        @input="sendValues" /> -->
                    <b-form-input v-model="third_name" placeholder="Third Name" @input="sendValues" />

                </b-form-group>
            </b-col>
            <b-col md="2">
                <b-form-group label="Fourth Name" label-for="forthName">
                    <!-- <v-select v-model="forth_name" label="title" :options="option" placeholder="Fourth name"
                        @input="sendValues" /> -->
                    <b-form-input v-model="forth_name" placeholder="Fourth Name" @input="sendValues" />

                </b-form-group>
            </b-col>
            <b-col>
                <slot></slot>
            </b-col>
            <!-- <b-col md="">
                <b-form-group label="Nickname" label-for="Nickname">
                    <v-select v-model="nickname" label="title" :options="option" placeholder="اللقب" @input="sendValues" />
                </b-form-group>
            </b-col> -->
        </b-row>
    </div>
</template>
<script>
import {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BLink,
    BDropdown,
    BDropdownItem,
    BTooltip,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    VBModal,
    BCardText,
    BFormCheckboxGroup,
    BFormCheckbox,
    BIcon,
    BIconArrowLeft,
    BIconXCircle,
    BIconExclamationCircle,
    BFormTextarea,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import VueHtml2pdf from "vue-html2pdf";
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';

export default {
    components: {
        BCard,
        BRow,
        BCol,
        BFormInput,
        BButton,
        BLink,
        BDropdown,
        BDropdownItem,
        BTooltip,
        vSelect,
        BFormGroup,
        BFormSelect,
        BSpinner,
        BModal,
        BCardText,
        BFormCheckbox,
        BFormCheckboxGroup,
        BIcon,
        BIconArrowLeft,
        BIconXCircle,
        BIconExclamationCircle,
        VueHtml2pdf,
        BFormTextarea,
        'step-progress': StepProgress,
    },
    data() {
        return {
            first_name: "",
            second_name: "",
            third_name: "",
            forth_name: "",
            nickname: '',
            option: [], 
        };
    },
    mounted() {
        // this.getNames();
    },
    methods: {
        sendValues() {
            const values = {
                first_name: this.first_name,
                second_name: this.second_name,
                third_name: this.third_name,
                forth_name: this.forth_name,
                nickname: this.nickname
            };
            this.$emit('values', values);
        },
        // async getNames() {
        //     await this.getListNames(`/verification/`);
        //     // remove the duplicate values from the names api
        //     // also reverse it to bring the last added names
        //     let Namesoption = this.names;
        //     const uniqueNames = [];
        //     Namesoption.map((element) => {
        //         const isDuplicate = uniqueNames.includes(element.title);
        //         if (!isDuplicate) {
        //             uniqueNames.push(element.title);
        //         }
        //     });
        //     this.option = uniqueNames;
        // },
    },
};
</script>
<style scoped>
.patient-table>tr>td {
    padding-left: 0.5rem;
    border: 1px solid;
    text-align: left;
}

.drugs-table>tr>td {
    border: 1px solid;
}

ul {
    list-style: none;
}

ul li:before {
    content: "✓";
    margin-right: 1rem;
}

table {
    width: 100%;
    background: white;
    border-collapse: collapse;
}

td {
    width: 6rem;
    text-align: center;
}

table.drugs-table>tr>td {
    text-align: center !important;
}

.table-input {
    display: inline;
    border: none;
    width: 50%;
}

.dailyTreatment-table>tr {
    height: 2.5rem;
}

.font-modify {
    letter-spacing: normal !important;
}

.pdf-content {
    margin: 2rem;
}

.checkbox-modify {
    margin-left: 1.5rem;
    margin-top: 1rem;
}

.show-table,
.show-table>tr,
.show-table>tr>td {
    border: 1px solid;
}

.show-table {
    /* margin-left: auto; */
    margin: auto;
    margin-top: 4rem;
    width: 70%;
}

.show-table>tr>td {
    padding: 0.9rem 0 0.9rem 0;
}

.show-table,
.show-table>tr,
.show-table>tr>td,
.show-table-2,
.show-table-2>tr,
.show-table-2>tr>td {
    border: 1px solid;
}

.show-table-2 {
    /* margin-left: auto; */
    margin: auto;
    margin-top: 2.5rem;
    width: 70%;
}

.show-table-2>tr>td {
    padding: 0.3rem 0 0.3rem 0;
}</style>